


import {Component, Vue} from "vue-property-decorator";
import api from '@/api'
import PagedTableView from "@/components/PagedTableView/index.vue";
import {OrganizationUnitDto, OrganizationUnitLevel, SplitBillDto} from "@/api/appService";

@Component({
  name: 'SplitBillList',
  components: {PagedTableView}
})
export default class SplitBillList extends Vue {

  tableItems: any[] = [];

  partialAreas: OrganizationUnitDto[] = []
  stores: OrganizationUnitDto[] = []

  queryForm: any = {
    billDate: '',
    storeId: undefined,
    partialAreaOrgId: undefined,
    onlyViewHasPayOrder: true
  }

  get currentOu(): OrganizationUnitDto {
    return this.$store.getters['user/ou'] as OrganizationUnitDto;
  }

  created() {
    if (!['门店', '片区'].includes(this.currentOu.level!)) {
      this.fetchAllPartialAreas();
    }
    if (this.currentOu.level !== '门店') {
      this.fetchStores();
    }


  }

  fetchData(params: any) {
    return api.splitBill.getAllBills(params)
  }

  viewBillDetail(row: SplitBillDto) {
    return this.$router.push({name: 'splitAccountBillDetails', params: {billId: row.id!.toString()}})
  }

  downloadBill(row:SplitBillDto){
    window.open(`${process.env.VUE_APP_BASE_API}/api/services/app/SplitBill/DownloadBill?billId=${row.id}`,'_blank')
  }

  formatAmount(row: any, column: any, cellValue: number) {
    return `￥${(cellValue / 100.0).toFixed(2)}`
  }

  formatPercent(row:any,column:any,cellValue:number){
    return `${cellValue.toFixed(2)}`
  }

  fetchAllPartialAreas() {
    api.organizationUnit.getOrganizationUnitsOfDescendantBySession({withMe: true}).then((orgs) => {
      this.partialAreas = orgs.filter(org => org.level === OrganizationUnitLevel.片区);
    })
  }

  fetchStores() {
    api.organizationUnit.getStoresBySession().then(orgs => {
      this.stores = orgs;
    })
  }

  handlePartialAreaSelect() {

    api.organizationUnit.getStoresBySession().then(res => {
      if (this.queryForm.partialAreaOrgId) {
        this.stores = res.filter(s => s.parentId === this.queryForm.partialAreaOrgId);
        if (this.queryForm.storeId && !this.stores.some(store => store.id === this.queryForm.storeId)) {
          this.queryForm.storeId = undefined
        }
      } else {
        this.stores = res;
      }
    })


  }

}

